import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';

const initialForm = {
  nomCategoria: '',
  activo: true,
};

const CategoriaModal = ({ show, onHide, onSave, categoriaEdit, categorias = [] }) => {
  const [formData, setFormData] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (categoriaEdit) {
      setFormData({
        nomCategoria: categoriaEdit.nomCategoria,
        activo: categoriaEdit.activo,
      });
    } else {
      setFormData(initialForm);
    }
    setError('');
  }, [categoriaEdit, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setError('');
  };

  const validateForm = () => {
    // Validar nombre no vacío
    if (!formData.nomCategoria.trim()) {
      setError('El nombre de la categoría es requerido');
      return false;
    }

    // Validar longitud máxima
    if (formData.nomCategoria.length > 50) {
      setError('El nombre no puede exceder 50 caracteres');
      return false;
    }

    // Validar nombre único (excepto si es edición de la misma categoría)
    const nombreExiste = categorias.some(
      (cat) =>
        cat.nomCategoria.toLowerCase() === formData.nomCategoria.trim().toLowerCase() &&
        cat.id !== categoriaEdit?.id
    );

    if (nombreExiste) {
      setError('Ya existe una categoría con este nombre');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      setSaving(true);
      setError('');
      
      await onSave({
        nomCategoria: formData.nomCategoria.trim(),
        activo: formData.activo,
      });
      
      onHide();
    } catch (err) {
      console.error(err);
      setError(err.message || 'Error al guardar la categoría');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={`fas ${categoriaEdit ? 'fa-edit' : 'fa-plus-circle'} me-2`}></i>
          {categoriaEdit ? 'Editar Categoría' : 'Nueva Categoría'}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError('')}>
              <i className="fas fa-exclamation-triangle me-2"></i>
              {error}
            </Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Nombre de la Categoría <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="nomCategoria"
              value={formData.nomCategoria}
              onChange={handleChange}
              placeholder="Ej: Cumpleaños, Aniversarios, etc."
              maxLength={50}
              required
              autoFocus
            />
            <Form.Text className="text-muted">
              {formData.nomCategoria.length}/50 caracteres
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="activo-switch"
              label={
                <span>
                  <i className={`fas ${formData.activo ? 'fa-check-circle text-success' : 'fa-times-circle text-secondary'} me-2`}></i>
                  Categoría activa
                </span>
              }
              name="activo"
              checked={formData.activo}
              onChange={handleChange}
            />
            <Form.Text className="text-muted">
              {formData.activo 
                ? 'La categoría estará disponible para asignar a productos' 
                : 'La categoría no estará disponible para nuevos productos'}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={saving}>
            <i className="fas fa-times me-2"></i>
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            type="submit" 
            disabled={saving}
            style={{ backgroundColor: '#c4956a', borderColor: '#c4956a' }}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Guardando...
              </>
            ) : (
              <>
                <i className="fas fa-save me-2"></i>
                Guardar Categoría
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CategoriaModal;
